/** Generate by swagger-axios-codegen */
// tslint:disable
/* eslint-disable */
import { AxiosInstance } from 'axios';
import { getCookie } from 'cookies-next';
import { IRequestConfig, IRequestOptions } from '@/shared/services/index'


// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};
// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url };
  const cookieToken = getCookie("access_token") ? ('Bearer ' + getCookie("access_token")) : undefined
  const localstorageToken = localStorage.getItem("access_token") ? ('Bearer ' + localStorage.getItem("access_token")) : undefined

  configs.headers = {
    ...options.headers,
    'Authorization': cookieToken ? cookieToken : localstorageToken ? localstorageToken : '',
    'Content-Type': contentType
  };
  return configs;
}

const basePath = '';

export interface IList<T> extends Array<T> { }
export interface List<T> extends Array<T> { }
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> { }

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

export interface IBalance {
  coin: number
  diamond: number
}

export interface IUserDTO {
  id: string
  display_name?: string
  user_name?: string
  status: number
  avatar?: string
  gender?: number
  email?: string
  description?: string
  balance?: IBalance
  roles?: RoleDTO[]
  is_first_login?: boolean
}

export interface IRoleDTO {
  id: string
  name: string
  code: string
  resources: ResourceDTO[]
  status: number
}

export interface IUserAdminDTO {
  id: string
  email: string
  roles?: IRoleDTO[]
  is_first_login?: boolean
}


export class LoginControllerService {
  private static controllerPath = '/login'

  /**
   * login
   */
  static login(
    body: {
      username?: string;
      password?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TokenInfoDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + this.controllerPath + '';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.data = {
        grant_type: 'password',
        username: body['username'],
        password: body['password']
      };
      axios(configs, resolve, reject);
    });
  }
}

export class LogoutControllerService {
  private static controllerPath = '/logout'

  /**
   * login
   */
  static logout(
    params: {
      redirect_url: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      let url = basePath + this.controllerPath + '';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        redirect_url: params['redirect_url']
      };
      configs.data = null
      axios(configs, resolve, reject);
    });
  }
}

export class PermissionControllerService {
  /**
   * getAllPermission
   */
  static getAllPermissionUsingGet(
    params: {
      /** trang bắt đầu từ 0 */
      keyword?: string;
      /** page */
      page?: number;
      /** số item của trang */
      size?: number;
      /** status:  */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_Permission> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/permission';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        keyword: params['keyword'],
        page: params['page'],
        size: params['size'],
        status: params['status']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createPermission
   */
  static createPermissionUsingPost(
    params: {
      /** permissionReq */
      permissionReq: PermissionReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/permission';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['permissionReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deletePermission
   */
  static deletePermissionUsingDelete(
    params: {
      /** permission_id */
      permissionId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/permission/delete/{permission_id}';
      url = url.replace('{permission_id}', params['permissionId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updatePermission
   */
  static updatePermissionUsingPut(
    params: {
      /** permission_id */
      permissionId: string;
      /** permissionReq */
      permissionReq: PermissionReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/permission/{permission_id}';
      url = url.replace('{permission_id}', params['permissionId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['permissionReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updatePermissionStatus
   */
  static updatePermissionStatusUsingPut(
    params: {
      /** permission_id */
      permissionId: string;
      /** status */
      status: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/permission/{permission_id}/status';
      url = url.replace('{permission_id}', params['permissionId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { status: params['status'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ResourceControllerService {
  /**
   * getAllResource
   */
  static getAllResourceUsingGet(
    params: {
      /** Từ khóa muốn tìm kiếm(hiện tại tìm kiếm theo tên) */
      keyword?: string;
      /** Page muốn lấy dữ liệu(page bắt đầu từ 0) */
      page?: number;
      /** số item của trang(Mặc định là 20) */
      size?: number;
      /** Trạng thái của resource */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_ResourceDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/resource';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        keyword: params['keyword'],
        page: params['page'],
        size: params['size'],
        status: params['status']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createResource
   */
  static createResourceUsingPost(
    params: {
      /** resourceReq */
      resourceReq: ResourceReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ResourceDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/resource';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['resourceReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteResource
   */
  static deleteResourceUsingDelete(
    params: {
      /** resource_id */
      resourceId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ResourceDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/resource/delete/{resource_id}';
      url = url.replace('{resource_id}', params['resourceId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateResource
   */
  static updateResourceUsingPut(
    params: {
      /** resource_id */
      resourceId: string;
      /** resourceReq */
      resourceReq: ResourceUpdateReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ResourceDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/resource/{resource_id}';
      url = url.replace('{resource_id}', params['resourceId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['resourceReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateResourceStatus
   */
  static updateResourceStatusUsingPut(
    params: {
      /** resource_id */
      resourceId: string;
      /** status */
      status: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ResourceDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/resource/{resource_id}/status';
      url = url.replace('{resource_id}', params['resourceId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['status'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class RoleControllerService {
  /**
   * getAllRole
   */
  static getAllRoleUsingGet(
    params: {
      /** Từ khóa muốn tìm kiếm(hiện tại tìm kiếm theo tên) */
      keyword?: string;
      /** Page muốn lấy dữ liệu(page bắt đầu từ 0) */
      page?: number;
      /** số item của trang(Mặc định là 20) */
      size?: number;
      /** Trạng thái của resource */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_RoleDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/role';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        keyword: params['keyword'],
        page: params['page'],
        size: params['size'],
        status: params['status']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createRole
   */
  static createRoleUsingPost(
    params: {
      /** roleReq */
      roleReq: RoleReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/role';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['roleReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }


  static getRoleByIdUsingGet(
    params: {
      /** roleID */
      roleId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/role/findById';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { roleID: params['roleId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUserById
   */
  static updateRoleByIdUsingPut(
    params: {
      /** role_id */
      roleId: string;
      /** roleReq */
      roleReq: RoleUpdateReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/role/{role_id}';
      url = url.replace('{role_id}', params['roleId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['roleReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteRole
   */
  static deleteRoleUsingDelete(
    params: {
      /** role_id */
      roleId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/role/{role_id}';
      url = url.replace('{role_id}', params['roleId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateStatus
   */
  static updateStatusUsingPut(
    params: {
      /** role_id */
      roleId: string;
      /** status */
      status: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/role/{role_id}/status';
      url = url.replace('{role_id}', params['roleId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['status'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class GameControllerService {
  /**
   * getAllGameWithPaging
   */
  static getAllGameWithPagingUsingGet(
    params: {
      /** Tên Game */
      name?: string;
      /** page */
      page?: number;
      /** size */
      size?: number;
      /** Status */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_GameDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/game';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { name: params['name'], page: params['page'], size: params['size'], status: params['status'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createGame
   */
  static createGameUsingPost(
    params: {
      /** gameRequest */
      gameRequest: GameRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GameDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/game';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['gameRequest'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * uploadHandler
   */
  static uploadHandlerUsingPost(
    params: {
      /**  */
      parts?: any;
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<R_string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/game/upload';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = new FormData();
      if (params['parts']) {
        if (Object.prototype.toString.call(params['parts']) === '[object Array]') {
          for (const item of params['parts']) {
            data.append('parts', item as any);
          }
        } else {
          data.append('parts', params['parts'] as any);
        }
      }

      if (params['id']) {
        if (Object.prototype.toString.call(params['id']) === '[object Array]') {
          for (const item of params['id']) {
            data.append('id', item as any);
          }
        } else {
          data.append('id', params['id'] as any);
        }
      }

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateGame
   */
  static updateGameUsingPut(
    params: {
      /** id */
      id: string;
      /** updateGameRequest */
      updateGameRequest: UpdateGameRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GameDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/game/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['updateGameRequest'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * delete
   */
  static deleteUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GameDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/game/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BankControllerService {
  /**
   * getAllBank
   */
  static getAllBankUsingGet(
    params: {
      /** keyword */
      keyword?: string;
      /** page */
      page?: number;
      /** size */
      size?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_Bank> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/bank';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { keyword: params['keyword'], page: params['page'], size: params['size'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createBank
   */
  static createBankUsingPost(
    params: {
      /** bankReq */
      bankReq: BankReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/bank';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['bankReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateBank
   */
  static updateBankUsingPut(
    params: {
      /** bankReq */
      bankReq: BankUpdateReq;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/bank/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['bankReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteBank
   */
  static deleteBankUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/bank/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BankBranchControllerService {
  /**
   * createBankBranch
   */
  static createBankBranchUsingPost(
    params: {
      /** bankBranchReq */
      bankBranchReq: BankBranchReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankBranchDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/bank-branch';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['bankBranchReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * getBankBranchByBankId
   */
  static getBankBranchByBankIdUsingGet(
    params: {
      /** bankId */
      bankId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankBranchDTO[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/bank-branch/{bankId}';
      url = url.replace('{bankId}', params['bankId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateBankBranch
   */
  static updateBankBranchUsingPut(
    params: {
      /** bankBranchReq */
      bankBranchReq: BankBranchReq;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankBranchDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/bank-branch/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['bankBranchReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteBankBranch
   */
  static deleteBankBranchUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankBranchDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/bank-branch/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UserAdminControllerService {
  private static controllerPath = '/auth/user'
  /**
   * getAllUserAdmin
   */
  static getAllUserAdminUsingGet(
    params: {
      /** Từ khóa muốn tìm kiếm(hiện tại tìm kiếm theo tên) */
      keyword?: string;
      /** Page muốn lấy dữ liệu(page bắt đầu từ 0) */
      page?: number;
      /** số item của trang(Mặc định là 20) */
      size?: number;
      /** Trạng thái của user */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_UserAdminDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/user';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        keyword: params['keyword'],
        page: params['page'],
        size: params['size'],
        status: params['status']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createUserAdmin
   */
  static createUserAdminUsingPost(
    params: {
      /** userAdminReq */
      userAdminReq: UserAdminReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAdminDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/user';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userAdminReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }


  static getUserAdminByIdUsingGet(
    params: {
      /** userId */
      userId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAdminDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/user/findById';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { userId: params['userId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUserById
   */
  static updateUserByIdUsingPut1(
    params: {
      /** user_id */
      userId: string;
      /** userAdminReq */
      userAdminReq: UserAdminReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAdminDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/user/{user_id}';
      url = url.replace('{user_id}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['userAdminReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateStatus
   */
  static updateStatusUsingPut1(
    params: {
      /** user_id */
      userId: string;
      /** userAdminUpdateStatus */
      userAdminUpdateStatus: UserAdminUpdateStatus;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAdminDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/user/{user_id}/status';
      url = url.replace('{user_id}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['userAdminUpdateStatus'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updatePassword
   */
  static updatePassword(
    params: {
      /** user_id */
      userId: string;
      /** password */
      pwd: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAdminDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/user/{user_id}/pwd';

      url = url.replace('{user_id}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['pwd'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * get admin profile
   * @param options
   */
  static getProfile(options: IRequestOptions = {}): Promise<IUserAdminDTO> {
    return new Promise((resolve, reject) => {
      const url = basePath + this.controllerPath + '/profile'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      axios(configs, resolve, reject)
    })
  }


  static deleteRoleUsingDelete1(
    params: {
      /** Role ID */
      roleId: string;
      /** User ID */
      userId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAdminDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/user/{user_id}/role/{role_id}';
      url = url.replace('{role_id}', params['roleId'] + '');
      url = url.replace('{user_id}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

// customer definition
// empty

export class CategoryControllerService {
  /**
   * getAllCategory
   */
  static getAllCategoryUsingGet(
    params: {
      /** page */
      page?: number;
      /** size */
      size?: number;
      /** status */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_Category> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/category';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { page: params['page'], size: params['size'], status: params['status'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createCategory
   */
  static createCategoryUsingPost(
    params: {
      /** category */
      category: Category;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Category> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/category';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['category'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }

  static countLiveByCategoryUsingGet(options: IRequestOptions = {}): Promise<CountLive[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/category/countLive';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }


  static getAllChildrenCategoryUsingGet(options: IRequestOptions = {}): Promise<Category[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/category/getAllChildrenCategory';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }


  static updateStatusCategoryUsingPut(
    params: {
      /** id */
      id: string;
      /** status */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Category> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/category/status/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { status: params['status'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateCategory
   */
  static updateCategoryUsingPut(
    params: {
      /** category */
      category: CategoryReq;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Category> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/category/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['category'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteCategory
   */
  static deleteCategoryUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Category> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/category/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class CommonControllerService {
  /**
   * getCommon
   */
  static getCommonUsingGet(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/common';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * setCommon
   */
  static setCommonUsingPost(
    params: {
      /** common */
      common: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<R> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/common';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['common'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class GiftCategoryControllerService {
  /**
   * getAllGiftGiftCategories
   */
  static getAllGiftGiftCategoriesUsingGet(
    params: {
      /** Từ khóa muốn tìm kiếm(hiện tại tìm kiếm theo tên) */
      keyword?: string;
      /** Page muốn lấy dữ liệu(page bắt đầu từ 0) */
      page?: number;
      /** số item của trang(Mặc định là 20) */
      size?: number;
      /** Trạng thái của Category */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_GiftCategoryDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/gift_category';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        keyword: params['keyword'],
        page: params['page'],
        size: params['size'],
        status: params['status']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createGiftCategory
   */
  static createGiftCategoryUsingPost(
    params: {
      /** giftCategoryReq */
      giftCategoryReq: GiftCategoryReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftCategoryDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/gift_category';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['giftCategoryReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * getGiftCategory
   */
  static getGiftCategoryUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftCategoryDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/gift_category/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateGiftCategory
   */
  static updateGiftCategoryUsingPut(
    params: {
      /** id */
      id: string;
      /** request */
      request: GiftCategoryReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftCategoryDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/gift_category/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteGiftCategory
   */
  static deleteGiftCategoryUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftCategoryDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/gift_category/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class GiftLiveControllerService {
  /**
   * getAllByFilter
   */
  static getAllByFilterUsingGet(
    params: {
      /** currency */
      currency?: number;
      /** gift_group */
      giftGroup?: string;
      /** limit_type */
      limitType?: string;
      /** status */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftCustomDTO[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/giftlive';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        currency: params['currency'],
        gift_group: params['giftGroup'],
        limit_type: params['limitType'],
        status: params['status']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createGiftLive
   */
  static createGiftLiveUsingPost(
    params: {
      /** giftLiveReq */
      giftLiveReq: GiftLiveReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftLiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/giftlive';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['giftLiveReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * findGiftLiveById
   */
  static findGiftLiveByIdUsingGet(
    params: {
      /** Gift Live Id */
      giftId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftLiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/giftlive/{giftId}';
      url = url.replace('{giftId}', params['giftId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateGiftLive
   */
  static updateGiftLiveUsingPut(
    params: {
      /** Gift Live Id */
      giftId: string;
      /** Chuỗi json chứa các thông tin update Gift Live */
      updateGiftLiveRequest: GiftLiveReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftLiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/giftlive/{giftId}';
      url = url.replace('{giftId}', params['giftId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['updateGiftLiveRequest'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteGiftLive
   */
  static deleteGiftLiveUsingDelete(
    params: {
      /** Gift Live Id */
      giftId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftLiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/giftlive/{giftId}';
      url = url.replace('{giftId}', params['giftId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateGiftLiveStatus
   */
  static updateGiftLiveStatusUsingPatch(
    params: {
      /** Gift Live id */
      giftId: string;
      /** status */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GiftLiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/giftlive/{giftId}';
      url = url.replace('{giftId}', params['giftId'] + '');

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);
      configs.params = { status: params['status'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class LiveControllerService {
  /**
   * getAllLive
   */
  static getAllLiveUsingGet(
    params: {
      /** from */
      from?: number;
      /** keyword */
      keyword?: string;
      /** page */
      page?: number;
      /** size */
      size?: number;
      /** status */
      status?: number;
      /** to */
      to?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_LiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/live';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        from: params['from'],
        keyword: params['keyword'],
        page: params['page'],
        size: params['size'],
        status: params['status'],
        to: params['to']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createLive
   */
  static createLiveUsingPost(
    params: {
      /** live */
      live: LiveDTO;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/live';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['live'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * getLiveByUser
   */
  static getLiveByUserUsingGet(
    params: {
      /** user_id */
      userId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/live/by-user';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { user_id: params['userId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * endLive
   */
  static endLiveUsingPost(
    params: {
      /** live_id */
      liveId: string;
      /** reason */
      reason: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/live/endSession';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { live_id: params['liveId'], reason: params['reason'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * getTopDistinct
   */
  static getTopDistinctUsingGet(options: IRequestOptions = {}): Promise<number[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/live/top';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }


  static updateLiveCmsUsingPut(
    params: {
      /** id */
      id: string;
      /** live */
      live: LiveReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LiveDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/live/updateLiveCms/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['live'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateLive
   */
  static updateLiveUsingPut(
    params: {
      /** id */
      id: string;
      /** live */
      live: LiveDTO;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<R> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/live/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['live'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteLive
   */
  static deleteLiveUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/live/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * upTop
   */
  static upTopUsingPut(
    params: {
      /** id */
      id: string;
      /** position */
      position: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LiveDTO[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/live/{id}/change_top';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { position: params['position'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class GiftHistoryControllerService {
  /**
   * getAllGiftHistory
   */
  static getAllGiftHistoryUsingGet(
    params: {
      /** currency */
      currency?: number;
      /** from */
      from?: number;
      /** limitType */
      limitType?: string;
      /** liveStreamId */
      liveStreamId?: string;
      /** page */
      page?: number;
      /** receiverId */
      receiverId?: string;
      /** senderId */
      senderId?: string;
      /** size */
      size?: number;
      /** to */
      to?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_GiftHistoryDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/gift-history';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        currency: params['currency'],
        from: params['from'],
        limitType: params['limitType'],
        liveStreamId: params['liveStreamId'],
        page: params['page'],
        receiverId: params['receiverId'],
        senderId: params['senderId'],
        size: params['size'],
        to: params['to']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}


export class FanClubControllerService {
  /**
   * getAllFanClubs
   */
  static getAllFanClubs(
    params: {
      keyword?: string;
      /** page */
      page?: number;
      /** size */
      size?: number;
      /** status */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_FanClubDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/fanclub';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        keyword: params['keyword'],
        page: params['page'],
        size: params['size'],
        status: params['status'],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }

  /**
   * changeStatusFanClub
   */
  static changeStatusFanClub(
    params: {
      /** id */
      fanclubId: string;
      status: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/fanclub/active';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      configs.params = {
        fanclub_id: params['fanclubId'],
        status: params['status']
      };

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * editBonusLoyalty
   */
  static editBonusLoyalty(
    params: {
      /** id */
      fanclubId: string;
      bonusLoyalty: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/fanclub/bonus-loyalty';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      configs.params = {
        fanclub_id: params['fanclubId'],
        bonus_loyalty: params['bonusLoyalty']
      };

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * getAllUserFanClubs
   */
  static getAllUserFanClubs(
    params: {
      fanclubId?: string;
      /** id */
      keyword?: string;
      /** page */
      page?: number;
      /** size */
      size?: number;
      /** status */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_UserFanClubDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/fanclub/' + params['fanclubId'];

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        keyword: params['keyword'],
        page: params['page'],
        size: params['size'],
        status: params['status'],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }

}

export class LoggingControllerService {
  /**
   * getAllLogging
   */
  static getAllLoggingUsingGet(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/logging';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * setLogging
   */
  static setLoggingUsingPut(
    params: {
      /** config */
      config: ConfigLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<R> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/logging';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['config'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * detailLogging
   */
  static detailLoggingUsingGet(
    params: {
      /** method */
      method: string;
      /** page */
      page: number;
      /** path */
      path: string;
      /** service_name */
      serviceName: string;
      /** size */
      size: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/logging/read';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        method: params['method'],
        page: params['page'],
        path: params['path'],
        service_name: params['serviceName'],
        size: params['size']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}


export class OrderTopUpControllerService {
  /**
   * getAllGiftHistory
   */
  static getAllGiftHistoryUsingGet1(
    params: {
      /** from */
      from?: number;
      /** page */
      page?: number;
      /** payChannel */
      payChannel?: string;
      /** size */
      size?: number;
      /** to */
      to?: number;
      /** transId */
      transId?: string;
      /** userId */
      userId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_OrderTopupDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/order-topup';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        from: params['from'],
        page: params['page'],
        payChannel: params['payChannel'],
        size: params['size'],
        to: params['to'],
        transId: params['transId'],
        userId: params['userId']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UserControllerService {
  /**
   * findUsers
   */
  static findUsersUsingGet(
    params: {
      /** keyword */
      keyword?: string;
      /** page */
      page?: number;
      /** size */
      size?: number;
      /** status */
      status?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_User> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/user';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        keyword: params['keyword'],
        page: params['page'],
        size: params['size'],
        status: params['status']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUser
   */
  static updateUserUsingPut(
    params: {
      /** user_id */
      userId: string;
      /** userReq */
      userReq: UserReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/user/{user_id}';
      url = url.replace('{user_id}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['userReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateStatus
   */
  static updateStatusUsingPut2(
    params: {
      /** status */
      status: number;
      /** user_id */
      userId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/user/{user_id}/status';
      url = url.replace('{user_id}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['status'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class LevelControllerService {
  /**
   * getAllLevelWithPaging
   */
  static getAllLevelWithPagingUsingGet(
    params: {
      /** Trang bắt đầu từ 0 */
      page?: number;
      /** Số item của trang */
      size?: number;
      /** Kiểu của Level */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_LevelDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/level';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { page: params['page'], size: params['size'], type: params['type'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createLevel
   */
  static createLevelUsingPost(
    params: {
      /** levelReq */
      levelReq: LevelReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LevelDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/level';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['levelReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateLevel
   */
  static updateLevelUsingPut(
    params: {
      /** id */
      id: string;
      /** levelReq */
      levelReq: LevelReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LevelDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/level/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['levelReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * delete
   */
  static deleteUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/level/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BeautyEffectControllerService {
  /**
   * getAllBeautyEffectWithPagingUsingGet
   */
  static getAllBeautyEffectWithPagingUsingGet(
    params: {
      /** Trang bắt đầu từ 0 */
      page?: number;
      /** Số item của trang */
      size?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_BeautyEffectDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/beauty-effect';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { page: params['page'], size: params['size'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createBeautyEffect
   */
  static createBeautyEffect(
    params: {
      /** levelReq */
      beautyEffectReq: BeautyEffectReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BeautyEffectDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/beauty-effect';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['beautyEffectReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateBeautyEffect
   */
  static updateBeautyEffect(
    params: {
      /** id */
      id: string;
      /** levelReq */
      beautyEffectReq: BeautyEffectReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BeautyEffectDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/beauty-effect/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['beautyEffectReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }

  /**
 * deleteBeautyEffect
 */
  static deleteBeautyEffect(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/beauty-effect/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class MissionControlerService {
  /**
   * getAllMissionWithPaging
   */
  static getAllMissionWithPagingUsingGet(
    params: {
      /** trang bắt đầu từ 0 */
      page?: number;
      /** role */
      role?: string;
      /** số item của trang */
      size?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_MissionDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mission';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { page: params['page'], role: params['role'], size: params['size'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * createMission
   */
  static createMissionUsingPost(
    params: {
      /** missionReq */
      missionReq: MissionReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MissionDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mission';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['missionReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * getAllMissionOfUser
   */
  static getAllMissionOfUserUsingGet(
    params: {
      /** id */
      id: string;
      /** trang bắt đầu từ 0 */
      page?: number;
      /** số item của trang */
      size?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MissionUserDTO[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mission/user/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { page: params['page'], size: params['size'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * addMissionToUsers
   */
  static addMissionToUsersUsingPost(
    params: {
      /** missionId */
      missionId: string;
      /** users */
      users: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MissionUserDTO[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mission/users';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { missionId: params['missionId'] };
      let data = params['users'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * updateMission
   */
  static updateMissionUsingPut(
    params: {
      /** id */
      id: string;
      /** missionReq */
      missionReq: MissionReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MissionDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mission/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['missionReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteMission
   */
  static deleteMissionUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mission/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }

  /**
   * changeStatusFanClub
   */
  static changeStatusMission(
    params: {
      /** id */
      missionId: string;
      status: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MissionDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mission/active';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      configs.params = {
        mission_id: params['missionId'],
        status: params['status']
      };

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}


export class LiveSessionControllerService {
  /**
   * getLiveSessionByFilter
   */
  static getLiveSessionByFilterUsingGet(
    params: {
      /** fromTime */
      fromTime?: number;
      /** liveId */
      liveId: string;
      /** page */
      page: number;
      /** size */
      size: number;
      /** status */
      status?: number;
      /** toTime */
      toTime?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PageWapper_LiveSession> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/livesession/{liveId}';
      url = url.replace('{liveId}', params['liveId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        fromTime: params['fromTime'],
        page: params['page'],
        size: params['size'],
        status: params['status'],
        toTime: params['toTime']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UserAdminInvitationControllerService {
  /**
   * request server to send verification mail
   */
  static invite(
    params: {
      /**UserAdmininvitationReq */
      invitationReq: UserAdminInvitationReq
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAdminInvitationDTO> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invitation_admin';
      // let url = "http://localhost:8083/invitation_admin";

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['invitationReq'];

      configs.data = data;
      axios(configs, resolve, reject);
    })
  }
}

export interface PageWapper_OrderTopupDTO {
  /**  */
  count?: number;

  /**  */
  page?: OrderTopupDTO[];
}

export interface OrderTopupDTO {
  /** Giá trị yêu cầu nạp */
  amount?: number;

  /** Id của gói trên db core */
  billing_package_id?: number;

  /** Giá gói mua */
  cost?: number;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /** Loại tiền dùng để mua gói */
  currency?: string;

  /** FID */
  fid?: string;

  /** Id của gói IAP (mapping billing_package_id) trên db core */
  iap_package_id?: string;

  /**  */
  id?: string;

  /** Loại gói (1: thường, 2: VIP) */
  package_type?: number;

  /** Giá trị nạp */
  pay_amount?: number;

  /** Thời gian nạp */
  pay_time?: Date;

  /** Phương thức thanh toán (APPLE, GOOGLE) */
  payment_method?: string;

  /** User id */
  request_id?: string;

  /** Trạng thái yêu cầu (1: Đang chờ, 2: Bị hủy, 3: Thanh công, 4: Thất bại) */
  status?: number;

  /** Id của gói trên chợ */
  store_package_id?: string;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;

  /** User id */
  user_id?: string;
}

export interface Balance {
  /**  */
  coin?: number;

  /**  */
  diamond?: number;
}
export interface MissionReq {
  /** Lượng phần thưởng nhận được khi hoàn thành nhiệm vụ */
  amount: number;

  /** Mô tả về nhiệm vu */
  description: string;

  /**  */
  exp?: number;

  /** Thời gian hết hạn của nhiệm vụ: 0: DAYLY; 1:WEEKLY; 2:MONTHLY */
  expire: string;

  /** Đường dẫn ảnh đại diện của nhiệm vụ */
  image_url: string;

  /** Kinh nghiệm giới hạn cho nhiệm vụ MULTI_LIMIT */
  limit?: number;

  /** Thong tin về nhiệm vu */
  name: string;

  /** Kiểu của phần thưởng khi hoàn thành nhiệm vụ: EXP; COIN ; DIAMOND ; GIFT */
  reward_type: string;

  /** Nhiệm vụ cho Role nào */
  role: string;

  /** Kiểu của nhiệm vụ: 0: SINGLE; 1: MULTI_LIMIT; 2:MULTI_UNLIMIT */
  type: string;
}

export interface UpdateGameRequest {
  /**  */
  code?: string;

  /**  */
  code_status?: boolean;

  /**  */
  name?: string;

  /**  */
  status?: number;

  /**  */
  url?: string;
}



export interface MissionDTO {
  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  exp?: number;

  /**  */
  expire?: string;

  /**  */
  id?: string;

  /**  */
  limit?: number;

  /**  */
  role?: number;

  /**  */
  total?: number;

  /**  */
  type?: string;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface MissionUserDTO {
  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  expire_status?: number;

  /**  */
  id?: string;

  /**  */
  mission?: MissionDTO;

  /**  */
  status?: number;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;

  /**  */
  user_id?: string;
}

export interface CountLive {
  /**  */
  category_id?: string;

  /**  */
  count?: number;
}

export interface PageWapper_User {
  /**  */
  count?: number;

  /**  */
  page?: User[];
}

export interface User {
  /**  */
  address?: Address;

  /**  */
  avatars?: string[];

  /**  */
  backpack?: BackpackItem[];

  /**  */
  balance?: Balance;

  /**  */
  birthday?: Date;

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  display_name?: string;

  /**  */
  email?: string;

  /**  */
  exp?: number;

  /**  */
  fanclub_setting?: FanClubSetting;

  /**  */
  fid?: string;

  /**  */
  follow_number?: number;

  /**  */
  gender?: number;

  /**  */
  id?: string;

  /**  */
  last_device_id?: string;

  /**  */
  level?: number;

  /**  */
  live?: Live;

  /**  */
  login_type?: string;

  /**  */
  matrimony?: number;

  /**  */
  phone_number?: string;

  /**  */
  search_histories?: string[];

  /**  */
  search_string?: string;

  /**  */
  setting?: UserSetting;

  /**  */
  status?: number;

  /**  */
  total_diamond_donate?: number;

  /**  */
  total_ruby_donated?: number;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  user_name?: string;

  /**  */
  version?: number;

  /**  */
  vip?: Vip;
}

export interface UserNotifySetting { }

export interface UserSetting {
  /**  */
  notify?: UserNotifySetting;
}

export interface Live {
  /**  */
  banner?: string;

  /**  */
  categories?: Category[];

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  ended_time?: Date;

  /**  */
  exp?: number;

  /**  */
  fake_view?: number;

  /**  */
  hot?: number;

  /**  */
  id?: string;

  /**  */
  live_session_newest?: LiveSession;


  /**  */
  newest_live_session?: string;

  /**  */
  recommend?: number;

  /**  */
  replay_url?: string;

  /**  */
  resolution?: string;

  /**  */
  search_number?: number;

  /**  */
  search_string?: string;

  /**  */
  secret?: string;

  /**  */
  started_time?: Date;

  /**  */
  status?: number;

  /**  */
  title?: string;

  /**  */
  top?: number;

  /**  */
  type?: number;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  user?: User;

  /**  */
  version?: number;

  /**  */
  watch_number?: number;
}




export interface BackpackItem {
  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  expired_time?: Date;

  /**  */
  gift?: GiftLive;

  /**  */
  id?: string;

  /**  */
  quantity?: number;

  /**  */
  received_time?: Date;

  /**  */
  type?: number;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}


export interface R_string {
  /**  */
  code?: number;

  /**  */
  data?: string;

  /**  */
  msg?: string;

  /**  */
  ts?: number;
}

export interface GiftLive {
  /** Đường dẫn file animation */
  animation?: string;

  /** Kiểu file animation(0: lotie, 1: svga) */
  assets_type?: number;

  /** Quà tặng được áp dụng cho nhóm người dùng nào (FAN, VIP) */
  assigned?: string;

  /**  */
  category?: GiftCategory;

  /**  */
  category_id?: string;

  /**  */
  cost?: GiftCost;

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  image?: string;

  /**  */
  name?: string;

  /** Vị trí item quà tặng được hiển thị trên ứng dụng */
  position?: number;

  /**  */
  status?: number;

  /** Kiểu quà tặng (0: Currency, 1: Item) */
  type?: number;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}



export interface FanClubSetting {
  /** Tự động đổi huy chương khi vào phòng( 0: inactive, 1: active)  */
  auto_change_badge?: number;

  /** Khi tặng quà sẽ tự động tham gia nhóm Fan ( 0: inactive, 1: active) */
  auto_join_fanclub?: number;
}

export interface Address {
  /**  */
  code?: number;

  /**  */
  name?: string;

  /**  */
  province?: Province;
}


export interface Province {
  /**  */
  code?: number;

  /**  */
  division_type?: string;

  /**  */
  name?: string;

  /**  */
  phone_code?: number;
}

export interface UserReq {
  /**  */
  balance?: Balance;

  /**  */
  user_level?: number;

  /**  */
  user_name?: string;
}

export interface Vip {
  /**  */
  cost?: number;

  /**  */
  cost_extend?: number;

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  discount?: number;

  /**  */
  duration?: number;

  /**  */
  end_time?: Date;

  /**  */
  id?: string;

  /**  */
  level?: number;

  /**  */
  logo_url?: string;

  /**  */
  name?: string;

  /**  */
  privileges?: object;

  /**  */
  start_time?: Date;

  /**  */
  status?: string;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}

export interface PageWapper_GameDTO {
  /**  */
  count?: number;

  /**  */
  page?: GameDTO[];
}

export interface LiveSessionDTO {
  /**  */
  ended_time?: Date;

  /** Số người xem lớn nhất tới thời điểm hiện tại */
  highest_viewer_count?: number;

  /**  */
  id?: string;

  /**  */
  live_id?: string;

  /**  */
  started_time?: Date;

  /** Tổng số hoa hồng nhận được tới thời điểm hiện tại */
  total_coin_donate?: number;

  /** Tổng số kim cương nhận được tới thời điểm hiện tại */
  total_diamond_donate?: number;

  /** Tổng số fan follow tới thời điểm hiện tại */
  total_follow_count?: number;

  /** Tổng số quà nhận được tới thời điiểm hiện tại */
  total_gift_count?: number;

  /**  */
  user_id?: string;
}

export interface BankBranch {
  /**  */
  bank_id?: string;

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}

export interface BankBranchDTO {
  id?: string;
  /**  */
  bank_id?: string;

  /**  */
  name?: string;
}

export interface BankBranchReq {
  /**  */
  bank_id?: string;

  /**  */
  name?: string;
}

export interface Bank {
  /**  */
  bank_branch?: BankBranch[];

  /**  */
  code?: string;

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  icon?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}


export interface PageWapper_Bank {
  /**  */
  count?: number;

  /**  */
  page?: Bank[];
}

export interface BankDTO {
  /**  */
  bank_branch?: BankBranch[];

  /**  */
  code?: string;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  icon?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface BankReq {
  /**  */
  bank_branch?: BankBranch[];

  /**  */
  code?: string;

  /**  */
  icon?: string;

  /**  */
  name?: string;
}

export interface BankUpdateReq {
  /**  */
  bank_branch?: BankBranch[];

  /**  */
  code?: string;

  /**  */
  code_status?: boolean;

  /**  */
  icon?: string;

  /**  */
  name?: string;
}



export interface GiftHistoryDTO {
  /**  */
  count?: number;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  gift_live?: GiftLiveDTO;

  /**  */
  id?: string;

  /**  */
  live_session?: LiveSessionDTO;

  /**  */
  receiver_id?: string;

  /**  */
  sender_id?: string;

  /**  */
  streamer?: UserDTO;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface PageWapper_GiftHistoryDTO {
  /**  */
  count?: number;

  /**  */
  page?: GiftHistoryDTO[];
}



export interface Banner {
  /**  */
  center?: string;

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  end?: string;

  /**  */
  icon?: string;

  /**  */
  id?: string;

  /**  */
  radius?: number;

  /**  */
  start?: string;

  /**  */
  status?: number;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}



export interface Category {
  /**  */
  animation_url?: string;

  /**  */
  banner?: Banner;

  /**  */
  childrens?: Category[];

  /**  */
  code?: string;

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: Language;

  /**  */
  parent_id?: string;

  /**  */
  status?: number;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}

export interface CategoryDTO {
  /**  */
  banner?: Icon;

  /**  */
  childrens?: Category[];

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: Language;

  /**  */
  status?: number;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface Icon {
  /**  */
  center?: string;

  /**  */
  end?: string;

  /**  */
  icon?: string;

  /**  */
  radius?: number;

  /**  */
  start?: string;
}

export interface ConfigLog {
  /**  */
  method?: string;

  /**  */
  path?: string;

  /**  */
  service?: string;

  /**  */
  value?: boolean;
}

export interface CategoryReq {
  /**  */
  banner?: Icon;

  /**  */
  childrens?: Category[];

  /**  */
  code?: string;

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: Language;

  /**  */
  name_status?: boolean;

  /**  */
  parent_id?: string;

  /**  */
  status?: number;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}

export interface GiftCost {
  /** Loại tiền mua quà tặng trong livestream. (0: Coin, 1: Diamond) */
  type?: number;

  /** Giá tiền mua quà tặng trong livestream. */
  value?: number;
}

export interface PageWapper_GiftCategoryDTO {
  /**  */
  count?: number;

  /**  */
  page?: GiftCategoryDTO[];
}

export interface PageWapper_LevelDTO {
  /**  */
  count?: number;

  /**  */
  page?: LevelDTO[];
}

export interface PageWapper_BeautyEffectDTO {
  /**  */
  count?: number;

  /**  */
  page?: BeautyEffectDTO[];
}



export interface PageWapper_MissionDTO {
  /**  */
  count?: number;

  /**  */
  page?: MissionDTO[];
}


export interface Language {
  /** Tên bằng tiếng Anh */
  en?: string;

  /** Tên bằng tiếng Việt */
  vn?: string;
}


export interface GameDTO {
  /** Code game */
  code?: string;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  id?: string;

  /** Tên game */
  name?: string;

  /** Trạng thái game */
  status?: number;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;

  /** Link chạy game trên webview */
  url?: string;
}

export interface GameRequest {
  /**  */
  code?: string;

  /**  */
  name?: string;

  /**  */
  url?: string;
}


export interface FanClubDTO {
  /**  */
  admin?: UserDTO;

  /**  */
  exp?: number;

  /**  */
  fans?: number;

  /**  */
  name?: string;

  /**  */
  actual_loyalty?: StatisticDTO;

  /**  */
  bonus_loyalty?: number;

  /**  */
  display_loyalty?: StatisticDTO;

  /** Thời gian update mới nhất document (Format: yyyyMMddHHmmss) */
  updated_time?: string;

  /** Thời gian tạo ra document (Format: yyyyMMddHHmmss) */
  created_time?: string;
}

export interface UserFanClubDTO {
  /**  */
  user?: UserDTO;

  /**  */
  fanclub?: FanClubDTO;

  /**  */
  exp?: number;

  /**  */
  status?: number;

  /**  */
  statistic?: StatisticDTO;

  /** Thời gian update mới nhất document (Format: yyyyMMddHHmmss) */
  updated_time?: string;

  /** Thời gian tạo ra document (Format: yyyyMMddHHmmss) */
  created_time?: string;
}

export interface LiveReq {
  /**  */
  banner?: string;

  /**  */
  categories?: string[];

  /**  */
  fake_view?: number;

  /**  */
  title?: string;
}


export interface StatisticDTO {
  /**  */
  all?: number;

  /**  */
  daily?: number;

  /**  */
  weekly?: number;

  /**  */
  monthly?: number;

  /**  */
  yernly?: number;
}
export interface LevelReq {
  /** Mức kinh nghiệm cần thiết để đạt tới cấp độ ( Giới hạn dưới) */
  bound: number;

  /** Mức kinh nghiệm của level */
  exp: number;

  /** Code của level(Duy nhất) */
  level: number;

  image?: string;

  /** Type của level */
  type: string;

  /** diem giam của level */
  reduce_exp: string;

  gift: GiftLiveReq

  quantity: string

}

export interface LevelDTO {
  /** Giới hạn đạt đến của level */
  bound?: number;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /** kinh nghiệm hiện tại */
  current_exp?: number;

  /** Lượng kinh nghiệm của Level */
  exp?: number;

  /**  */
  id?: string;

  /** level hiện tại */
  level?: number;

  /** kinh nghiệm cần đạt */
  needed_exp?: number;

  /** Kiểu của level */
  type?: string;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface BeautyEffectReq {

  /** url */
  link?: string;

  /** trạng thái */
  status?: string;
}

export interface BeautyEffectDTO {

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  id?: string;

  /** url */
  link?: string;

  /** trạng thái của level */
  status?: string;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface LiveDTO {
  /**  */
  banner?: string;

  /**  */
  categories?: CategoryDTO[];

  /**  */
  category_id?: string;

  /**  */
  coin?: number;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  diamond?: number;

  /**  */
  ended_time?: Date;

  /**  */
  fake_view?: number;

  /**  */
  hot?: number;

  /**  */
  id?: string;

  /**  */
  location?: object;

  /**  */
  newest_live_session?: string;

  /**  */
  playback_url?: string;

  /**  */
  recommend?: number;

  /**  */
  replay_url?: string;

  /**  */
  resolution?: string;

  /**  */
  search_number?: number;

  /**  */
  search_string?: string;

  /**  */
  secret?: string;

  /**  */
  started_time?: Date;

  /**  */
  status?: number;

  /**  */
  tags?: string[];

  /**  */
  title?: string;

  /**  */
  top?: number;

  /**  */
  type?: number;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;

  /**  */
  user?: UserDTO;

  /**  */
  watch_number?: number;
}



export interface PageWapper_Category {
  /**  */
  count?: number;

  /**  */
  page?: Category[];
}

export interface GiftCustomDTO {
  /**  */
  category_id?: string;

  /**  */
  items?: GiftLiveDTO[];

  /**  */
  sorting?: number;
}

export interface UserAdminUpdateStatus {
  /**  */
  status?: number;
}

export interface PageWapper_GiftLive {
  /**  */
  count?: number;

  /**  */
  page?: GiftLiveDTO[];
}

export interface PageWapper_LiveDTO {
  /**  */
  count?: number;

  /**  */
  page?: LiveDTO[];
}

export interface PageWapper_FanClubDTO {
  /**  */
  count?: number;

  /**  */
  page?: FanClubDTO[];
}

export interface PageWapper_UserFanClubDTO {
  /**  */
  count?: number;

  /**  */
  page?: UserFanClubDTO[];
}

export interface PageWapper_UserDTO {
  /**  */
  count?: number;

  /**  */
  page?: UserDTO[];
}

export interface PageWapper_LiveSession {
  /**  */
  count?: number;

  /**  */
  page?: LiveSession[];
}

export interface R {
  /**  */
  code?: number;

  /**  */
  data?: object;

  /**  */
  msg?: string;
}

export interface UserDTO {
  /** Link ảnh đại */
  avatar?: string;

  /** Thông tin tài khoản user */
  balance?: Balance;

  /** Thời gian tạo ra document (Format: yyyyMMddHHmmss) */
  created_time?: string;

  /** Giới thiệu bản thân */
  description?: string;

  /** Tên hiển thị của người dùng */
  display_name?: string;

  /** Địa chỉ email của người dùng */
  email?: string;

  /** Danh sách user mà người dùng đã follow */
  follows?: string[];

  /** Giới tính(0: Nữ; 1: Nam; 2: Ẩn Danh) */
  gender?: number;

  /**  */
  id?: string;

  level?: number

  /** Trạng thái đăng nhập của người dùng */
  status?: number;

  /** Thời gian update mới nhất document (Format: yyyyMMddHHmmss) */
  updated_time?: string;

  /** Tên đăng nhập của người dùng */
  user_name?: string;
}

export interface GiftCategory {
  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  parent_id?: string;

  /** Vị trí item quà tặng được hiển thị trên ứng dụng */
  position?: number;

  /**  */
  status?: number;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}

export interface ResourceUpdateReq {
  /**  */
  code?: string;

  /**  */
  code_status?: boolean;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  path?: string;

  /**  */
  permissions?: PermissionReq[];

  /**  */
  status?: number;
}

export interface GiftCategoryDTO {

  childrens?: GiftCategoryDTO[];
  /**  */
  created_by?: string;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  id?: string;

  /**  */
  name?: string;


  sorting?: number;

  /**  */
  parent_id?: string;

  /**  */
  position?: number;

  /**  */
  status?: number;

  /**  */
  updated_by?: string;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface GiftCategoryReq {
  /** Tên Category */
  name?: string;
  /** Id của cấp cha, nếu null thì bản ghi là gốc */
  parent_id?: string;
  /** Vị trí item quà tặng được hiển thị trên ứng dụng */
  position?: number;

  sorting?: number;
  /** Trạng thái hiện hay ẩn (1: Hiện; 0: Ẩn) */
  status?: number;
}

export interface GiftCost {
  /** Loại tiền mua quà tặng trong livestream. (0: Coin, 1: Diamond) */
  type?: number;

  /** Giá tiền mua quà tặng trong livestream. */
  value?: number;
}

export interface GiftCost {
  /** Loại tiền mua quà tặng trong livestream. (0: Coin, 1: Diamond) */
  type?: number;

  /** Giá tiền mua quà tặng trong livestream. */
  value?: number;
}
export interface PageWapper_GiftLiveDTO {
  /**  */
  count?: number;

  /**  */
  page?: GiftLiveDTO[];
}

export interface GiftLiveDTO {
  /**  */
  animation?: string;

  /**  */
  assets_type?: number;

  /**  */
  assigned?: string;

  /**  */
  category?: GiftCategory;

  /**  */
  category_id?: string;

  /**  */
  cost?: GiftCost;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  image?: string;

  /**  */
  name?: string;

  /**  */
  position?: number;

  /**  */
  status?: number;

  /**  */
  type?: number;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface GiftLiveReq {
  /** Đường dẫn file animation */
  animation?: string;

  /** Kiểu file animation (0: lotie, 1: svga) */
  assets_type?: number;

  /** Quà tặng được áp dụng cho nhóm người dùng nào */
  assigned?: string;

  /** Id của group (category) mà gift thuộc về */
  category_id?: string;

  /**  */
  cost?: GiftCost;

  /** Mô tả gift */
  description?: string;

  /** Link Ảnh */
  image?: string;

  /** Tên gift */
  name?: string;

  /** Vị trí item quà tặng được hiển thị trên ứng dụng */
  position?: number;

  /** Trạng thái gift live (0: inactive, 1: active) */
  status?: number;

  /** Kiểu quà tặng (0: Currency, 1: Item) */
  type?: number;
}
export interface LiveSession {
  /**  */
  created_time?: Date;

  /**  */
  ended_time?: Date;

  /**  */
  highest_viewer_count?: number;

  /**  */
  id?: string;

  /**  */
  live_id?: string;

  /**  */
  replay_url?: string;

  /**  */
  started_time?: Date;

  /**  */
  status?: string;

  /**  */
  total_diamond_donate?: number;

  /**  */
  total_gift_count?: number;

  /**  */
  updated_time?: Date;

  /**  */
  user_id?: string;

  /**  */
  version?: number;

  /**  */
  video?: Video;
}

export interface Video {
  /**  */
  category_id?: string;

  /**  */
  coin?: number;

  /**  */
  created_time?: Date;

  /**  */
  description?: string;

  /**  */
  diamond?: number;

  /**  */
  id?: string;

  /**  */
  live_session_id?: string;

  /**  */
  play_url?: string;

  /**  */
  replay?: number;

  /**  */
  status?: number;

  /**  */
  title?: string;

  /**  */
  type?: number;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}

export interface PageWapper_Permission {
  /**  */
  count?: number;

  /**  */
  page?: Permission[];
}

export interface PageWapper_ResourceDTO {
  /**  */
  count?: number;

  /**  */
  page?: ResourceDTO[];
}

export interface PageWapper_RoleDTO {
  /**  */
  count?: number;

  /**  */
  page?: RoleDTO[];
}

export interface TokenInfoDTO {
  token_type?: string;
  access_token?: string;
  refresh_token?: string;
  expires_in?: number;
}

export interface PageWapper_UserAdminDTO {
  /**  */
  count?: number;

  /**  */
  page?: UserAdminDTO[];
}


export interface Permission {
  /**  */
  code?: string;

  /**  */
  created_by?: string;

  /**  */
  created_time?: Date;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  status?: number;

  /**  */
  updated_by?: string;

  /**  */
  updated_time?: Date;

  /**  */
  version?: number;
}

export interface PermissionDTO {
  /**  */
  code?: string;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  status?: number;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface PermissionUpdateReq {
  /**  */
  code?: string;

  /**  */
  code_status?: boolean;

  /**  */
  name?: string;

  /**  */
  status?: number;
}

export interface PermissionReq {
  /**  */
  code?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface R {
  /**  */
  code?: number;

  /**  */
  data?: object;

  /**  */
  msg?: string;
}

export interface ResourceDTO {
  /**  */
  code?: string;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  path?: string;

  /**  */
  permissions?: PermissionDTO[];

  /**  */
  status?: number;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;
}

export interface ResourceReq {
  /**  */
  code?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  path?: string;
}

export interface RoleDTO {
  /**  */
  code?: string;

  /** Thời gian tạo ra document (Format: timestamp milisecond) */
  created_time?: Date;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  resources?: ResourceDTO[];

  /**  */
  status?: number;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;

  checked?: boolean
}

export interface PermissionReq {
  /**  */
  code?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface ResourceReq {
  /**  */
  code?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  path?: string;

  /**  */
  permissions?: PermissionReq[];
}

export interface UserAdminReq {
  /**  */
  email?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  password?: string;

  /**  */
  roles?: RoleReq[];
}

export interface RoleReq {
  /**  */
  code?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  resources?: ResourceReq[];
}


export interface RoleUpdateReq {
  /**  */
  code?: string;

  /**  */
  code_status?: boolean;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  resources?: ResourceReq[];

  /**  */
  status?: number;
}

export interface TokenInfo {
  /** Access Token dùng để request các api khác */
  access_token?: string;

  /** Link ảnh đại */
  avatars?: string[];

  /** Tài chính của người dùng */
  balance?: Balance;

  /** Giới thiệu bản thân */
  description?: string;

  /** Tên hiển thị của người dùng */
  display_name?: string;

  /** Địa chỉ email của người dùng */
  email?: string;

  /** Danh sách user_id mà người dùng đã follow */
  follows?: string[];

  /** Giới tính(0: Nữ; 1: Nam; 2: Ẩn Danh) */
  gender?: number;

  /** User id */
  id?: string;

  /** Refresh Token dùng để lấy accessToken mới */
  refresh_token?: string;

  /** Danh sách lịch sử tìm kiếm của user */
  search_histories?: string[];

  /** Trạng thái online (1: Online, 0: Offline) */
  status?: number;

  /** User name */
  user_name?: string;
}

export interface UserAdminDTO {

  name?: string;

  status?: number;

  /**  */
  email?: string;

  /**  */
  id?: string;

  password?: string;

  /**  */
  roles?: RoleDTO[];

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;

  created_time?: Date;

  is_first_login?: boolean;
}

export interface UserAdminReq {
  /**  */
  email?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  password?: string;

  /**  */
  roles?: RoleReq[];
}

export interface UserAdminInvitationDTO {
  /**  */
  id?: string;

  /**  */
  email?: string;

  /**  */
  roles?: RoleDTO[];

  /** Thời gian tài khoản hết hiệu lực */
  expire?: Date;

  /** Thời gian update mới nhất document (Format: milisecond) */
  updated_time?: Date;

  created_time?: Date;
}

export interface UserAdminInvitationReq {
  /**  */
  email?: string;

  /**  */
  roles?: RoleReq[];

  /** Thời gian tài khoản hết hiệu lực */
  expire?: Number;
}
